import { FC } from 'react';
import Chip from './Chip';
import Flex from './Flex';

type SummaryRowValueType =
  | string
  | number
  | boolean
  | (() => string)
  | { label: string }
  | null
  | undefined
  | string[]
  | { label: string }[];

type SummaryRowProps = {
  section?: string;
  keyPart: string;
  label: string;
  value: SummaryRowValueType;
};

const SummaryRow: FC<SummaryRowProps> = props => {
  const { section, keyPart, label, value } = props;
  let v = '';
  let a: string[] | undefined = undefined;
  if (value === null || value === undefined) {
    v = '';
  } else if (typeof value == 'boolean') {
    v = value ? 'Yes' : 'No';
  } else if (typeof value == 'number') {
    v = value.toString();
  } else if (typeof value == 'function') {
    v = value();
  } else if (typeof value == 'string') {
    v = value;
  } else if (typeof value == 'object' && value['label'] !== undefined) {
    v = value['label'];
  } else if (Array.isArray(value)) {
    if (value.length > 0) {
      if (typeof value[0] === 'string') {
        const x: string[] = value as any;
        a = x;
      } else {
        const x: { label: string }[] = value as any;
        a = x.map(x => x.label);
      }
    } else {
      a = [];
    }
  }

  return (
    <Flex key={`${section || 'section'}.${keyPart}`} direction="row" size="1" alignItems="center" minHeight="40px">
      <Flex direction="row" size="1">
        {label}
      </Flex>
      <Flex direction="row" size="2" justify="flex-end">
        {a !== undefined ? a.map((x, i) => <Chip key={`${section || 'section'}.${keyPart}[${i}]`} text={x} />) : v}
      </Flex>
    </Flex>
  );
};

export default SummaryRow;
